import itemProviderReducer from './itemProviderReducer';

export default itemProviderReducer;